import cx from 'classnames';
import { Content, Subtitle } from '@/ev/styles';
import { appAssetsCdnUrl } from '~/constants/environment';

type LevelGuideProps = {
  level: '1' | '2' | '3';
};

function Text({ level }: LevelGuideProps) {
  switch (level) {
    case '1':
      return (
        <Content>
          Level 1 charging uses a standard 120-volt outlet, like what you would
          charge your phone with. This type of charging takes a long time
          though—around 40 hours for an EV!
        </Content>
      );
    case '2':
      return (
        <Content>
          Level 2 charging uses a 240-volt outlet, such as what you’d see for an
          electric dryer. Level 2 charging will charge about ten times faster
          than Level 1, so most EV owners choose to have a Level 2 charger
          installed.
        </Content>
      );
    case '3':
      return (
        <Content>
          Level 3 charging either uses a DC Fast Charger or a Tesla
          Supercharger. They can charge up
          <span className="font-bold"> 3 to 20 miles in a minute, </span>whereas
          Level 2 charging can only deliver 12 to 80 miles per hour. That’s a
          significant difference!
        </Content>
      );
    default:
      return null;
  }
}

export default function LevelGuide({ level }: LevelGuideProps) {
  const baseUrl = `${appAssetsCdnUrl}/svgs`;

  return (
    <div className="grid grid-rows-[200px_auto] gap-xl sm:grid-rows-[256px_auto] sm:gap-3xl md:grid-rows-[240px_auto]">
      <div className="grid items-end justify-center">
        <img
          src={`${baseUrl}/ev-charging-level-${level}.svg`}
          alt={`Level ${level} Charger`}
          className={cx(
            'my-auto',
            level === '3'
              ? 'h-[148px] sm:mb-[23px] sm:h-[193px] md:my-auto'
              : 'h-[128px] sm:h-[166px] md:mt-[50px]'
          )}
        />
      </div>
      <div className="grid items-start gap-md pr-xl">
        <Subtitle>Level {level}</Subtitle>
        <Text level={level} />
      </div>
    </div>
  );
}
